(ns ui.components.alert-list.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::alerts
 (fn [db [_ list-id]]
   (let [list-id (or list-id :default)]
     (get-in db [::alerts list-id]))))
